import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { POPULATION_PAGE } from './population.js';

mountLearnPage(POPULATION_PAGE);
